import { ReactElement, lazy, Suspense } from 'react';
import { Routes, Route, Navigate, unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';

import { ModelViewerSkeletonProvider, ModelChooserSkeletonProvider } from '@digital-dealer/modules/skeletons';
import { sharedHistory, getModelViewerRoutePath, getModelChooserRoutePath } from '@digital-dealer/routing';
import { ILazyComponent } from '@digital-dealer/types';
import type { IModelViewerModuleProps } from '@digital-dealer/modules/model-viewer';
import type { IModelChooserModuleProps } from '@digital-dealer/modules/model-chooser';

const ModelChooserModule = lazy((): Promise<ILazyComponent<IModelChooserModuleProps>> => import('@digital-dealer/modules/model-chooser'));
const ModelChooser = lazy((): Promise<ILazyComponent> => import('./modules/model-chooser'));

const ModelViewerModule = lazy((): Promise<ILazyComponent<IModelViewerModuleProps>> => import('@digital-dealer/modules/model-viewer'));
const ModelViewer = lazy((): Promise<ILazyComponent> => import('./modules/model-viewer'));

const futureFlags = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};

const RoutingRules = (): ReactElement => (
  <HistoryRouter
    history={sharedHistory as never}
    future={futureFlags}
  >
    <Routes>
      <Route
        path={getModelChooserRoutePath()}
        element={(
          <Suspense fallback={<ModelChooserSkeletonProvider showSkeleton />}>
            <ModelChooserModule ModelChooser={ModelChooser} />
          </Suspense>
        )}
      />

      <Route
        path={`${getModelViewerRoutePath()}/*`}
        element={(
          <Suspense fallback={<ModelViewerSkeletonProvider showSkeleton />}>
            <ModelViewerModule ModelViewer={ModelViewer} />
          </Suspense>
        )}
      />

      <Route
        path="*"
        element={<Navigate to={getModelChooserRoutePath()} replace />}
      />
    </Routes>
  </HistoryRouter>
);

export default RoutingRules;
